import { render, staticRenderFns } from "./BasePointTable.vue?vue&type=template&id=631bfec7"
import script from "./BasePointTable.vue?vue&type=script&lang=js"
export * from "./BasePointTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports